import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../controls/table/table.jsx';
import { actionOperations } from '../../actions/operations_actions.jsx';
import MediaQuery from 'react-responsive';
import TankStatus from '../tanks/tank/tank_status.jsx';
import { withTranslation } from 'react-i18next';
import * as FileSaver from 'file-saver';
import Loader from '../controls/loader/loader.jsx';

const Columns = [
    //{
    //    header: "Operations.cardNumber",
    //    name: "cardNumber",
    //    dataType: "text"
    //},
    {
        header: "Operations.userName",
        name: "userName",
        dataType: "text",
        sortProperty: "UserName"
    },
    {
        header: "Operations.startOperationTs",
        name: "startOperationTs",
        dataType: "datetime",
        sortProperty: "StartOperationTs"
    },
    {
        header: "Operations.endOperationTs",
        name: "operationTs",
        dataType: "datetime",
        sortProperty: "OperationTs"
    },
    //{
    //    header: "Operations.deviceImei",
    //    name: "deviceImei",
    //    dataType: "text"
    //},
    //{
    //    header: "Operations.rawVolumeData",
    //    name: "rawVolumeData",
    //    dataType: "int"
    //},
    {
        header: "Operations.volume",
        name: "volume",
        dataType: "float",
        sortProperty: "Volume"
    },
    {
        header: "Tanks.fuelType",
        name: "fuelType",
        dataType: "text",
        sortProperty: "FuelType"
    },

    {
        header: "Tanks.tankName",
        name: "tankName",
        dataType: "text",
        sortProperty: "TankName"
    },
    {
        header: "Operations.tankBalance",
        name: "tankBalance",
        dataType: "text",
        sortProperty: "TankBalance"
    }
];

const MobileColumns = [
    {
        header: "Operations.userName",
        name: "userName",
        dataType: "text"
    },
    {
        header: "Operations.volume",
        name: "volume",
        dataType: "float"
    },
    {
        header: "Operations.operationTs",
        name: "operationTs",
        dataType: "datetime"
    }
];

class OperationsListt extends React.Component {

    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.getReport = this.getReport.bind(this);
        this.getFilteredItems = this.getFilteredItems.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData(filter) {
        filter = filter ? filter : this.props.filter;
        this.props.getOperations(filter);
    }

    getFilteredItems(modelFilter) {
        let filter = this.props.filter;
        filter.modelFilter = modelFilter;
        this.getData(filter);
    }

    getReport() {
        this.props.getReport().then(data => {
            FileSaver.saveAs(data, 'operations.xlsx');
        });
        
    }

    render() {
        let modelFilter = {
            userName: {
                name: "userName",
                type: "string",
                header: this.props.i18n.t('Operations.Filter.userName'),
                value: this.props.filter.modelFilter.userName
            },
            dateTime: {
                name: "dateTime",
                type: "dates",
                dateFrom: {
                    name: "dateFrom",
                    header: this.props.i18n.t("Operations.Filter.dateFrom"),
                    value: this.props.filter.modelFilter.dateFrom
                },
                dateTo: {
                    name: "dateTo",
                    header: this.props.i18n.t("Operations.Filter.dateTo"),
                    value: this.props.filter.modelFilter.dateTo
                }
            }
        };

        return (
            <div>
                <MediaQuery minDeviceWidth={1224}>
                    <Table settings={{
                    columns: Columns,
                    items: this.props.operations,
                    itemsFilter: Object.assign({}, this.props.filter, { filterProps: modelFilter}),
                    isEditable: false,
                    getItemsFunction: this.getData,
                    getReportFunction: this.getReport
                    }} />
                    {this.props.loading && <Loader />}
                    </MediaQuery>
                <MediaQuery maxDeviceWidth={1224}>
                    <Table settings={{
                        columns: MobileColumns,
                        items: this.props.operations,
                        itemsFilter: Object.assign({}, this.props.filter, { filterProps: modelFilter }),
                        isEditable: false,
                        getItemsFunction: this.getData,
                        getReportFunction: this.getReport
                    }} />
                        
                </MediaQuery>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        operations: state.operations.operations,
        filter: state.operations.filter,
        loading: state.operations.loading,
        errors: state.operations.errors,
        forceReload: state.operations.forceReload
    };
}

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(actionOperations, dispatch))
(withTranslation('translantions')(OperationsListt));